export const hamSubCategoryNavTemplate = (itemID) =>`
<nav id="ham-${itemID}" class="subcat-nav ham-drop-menu"></nav>
`